import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import './bookings.css';
import './users.css';
import { supabase } from '../supabaseClient';
import Preloader from '../componets/layout/preloader';

const Bookings = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [filterCategory, setFilterCategory] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [search, setSearch] = useState('');
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);    const initialEditForm = {
        status: "", ticket_count: 0, total_price: 0, booking_date: "",
        email: "", user_id: "", event_id: "", category_id: ""
    };
    const [editForm, setEditForm] = useState(initialEditForm);

    useEffect(() => {
        const getData = async () => {
            const { data } = await supabase.from('bookings').select('*, users(full_name), events(title_en), categories(name_en)');
            setData(data);
            setLoading(false);
        };
        const getCategories = async () => {
            const { data } = await supabase.from('categories').select('id, name_en');
            if (data) setCategories(data);
        };
        const getEvents = async () => {
            const { data } = await supabase.from('events').select('id, title_en');
            if (data) setEvents(data);
        };
        const getUsers = async () => {
            const { data } = await supabase.from('users').select('id, full_name');
            if (data) setUsers(data);
        };
        getData();
        getCategories();
        getEvents();
        getUsers();
    }, []);

    const openEditModal = (item) => {
        setEditItem(item);
        setEditForm({
            status: item.status,
            ticket_count: item.ticket_count,
            total_price: item.total_price,
            booking_date: item.booking_date,
            email: item.email || "",
            user_id: item.user_id || "",
            event_id: item.event_id || "",
            category_id: item.category_id || ""
        });
        setEditModalOpen(true);
    };

    const updateBooking = async (e) => {
        e.preventDefault();
        const updatePayload = {
            status: editForm.status,
            ticket_count: editForm.ticket_count,
            total_price: editForm.total_price,
            booking_date: editForm.booking_date,
            email: editForm.email,
            user_id: editForm.user_id,
            event_id: editForm.event_id,
            category_id: editForm.category_id
        };
        const { error } = await supabase.from('bookings').update(updatePayload).eq('id', editItem.id);
        if (!error) {
            const updatedUser = users.find(u => u.id === editForm.user_id);
            const updatedEvent = events.find(ev => ev.id === Number(editForm.event_id));
            const updatedCategory = categories.find(c => c.id === Number(editForm.category_id));
            setData(prev => prev.map(item => item.id === editItem.id ? {
                ...item,
                ...updatePayload,
                users: updatedUser ? { full_name: updatedUser.full_name } : item.users,
                events: updatedEvent ? { title_en: updatedEvent.title_en } : item.events,
                categories: updatedCategory ? { name_en: updatedCategory.name_en } : item.categories
            } : item));
            setEditModalOpen(false);
        }
    };

    const handleDelete = async (id) => {
        await supabase.from('bookings').delete().eq('id', id);
        setData(prev => prev.filter(item => item.id !== id));
    };

    const filtered = data.filter(item => {
        const matchCategory = filterCategory === '' || String(item.category_id) === filterCategory;
        const matchStatus = filterStatus === '' || item.status === filterStatus;
        const matchSearch = search === '' ||
            item.users?.full_name?.toLowerCase().includes(search.toLowerCase()) ||
            item.email?.toLowerCase().includes(search.toLowerCase()) ||
            item.events?.title_en?.toLowerCase().includes(search.toLowerCase()) ||
            String(item.booking_id)?.toLowerCase().includes(search.toLowerCase());
        return matchCategory && matchStatus && matchSearch;
    });

    return (
        <>
                    <Preloader />

            {editModalOpen && (
                <div className="us-overlay">
                    <div className="us-modal">
                        <div className="us-modal-header">
                            <h2 className="us-modal-title">Edit Booking</h2>
                            <svg className="us-modal-close" onClick={() => setEditModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="us-modal-body">
                            <form className="us-form" onSubmit={updateBooking}>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Customer</label>
                                        <select className="us-form-select" value={editForm.user_id} onChange={(e) => setEditForm({...editForm, user_id: e.target.value})}>
                                            {users.map(u => (
                                                <option key={u.id} value={u.id}>{u.full_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Customer Email</label>
                                        <input type="email" className="us-form-input" value={editForm.email} onChange={(e) => setEditForm({...editForm, email: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Event</label>
                                        <select className="us-form-select" value={editForm.event_id} onChange={(e) => setEditForm({...editForm, event_id: e.target.value})}>
                                            {events.map(ev => (
                                                <option key={ev.id} value={ev.id}>{ev.title_en}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Category</label>
                                        <select className="us-form-select" value={editForm.category_id} onChange={(e) => setEditForm({...editForm, category_id: e.target.value})}>
                                            {categories.map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.name_en}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Status</label>
                                        <select required className="us-form-select" value={editForm.status} onChange={(e) => setEditForm({...editForm, status: e.target.value})}>
                                            <option value="Pending">Pending</option>
                                            <option value="Confirmed">Confirmed</option>
                                            <option value="Failed">Failed</option>
                                        </select>
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Booking Date</label>
                                        <input required type="date" className="us-form-input" value={editForm.booking_date} onChange={(e) => setEditForm({...editForm, booking_date: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Ticket Count</label>
                                        <input required type="number" className="us-form-input" value={editForm.ticket_count} onChange={(e) => setEditForm({...editForm, ticket_count: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Total Price ($)</label>
                                        <input required type="number" className="us-form-input" value={editForm.total_price} onChange={(e) => setEditForm({...editForm, total_price: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-footer">
                                    <button type="button" className="us-cancel-btn" onClick={() => setEditModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="us-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Update Booking
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <DashLayout title="Bookings Management" active="bookings">
                <div className="bk-top">
                    <h1 className="bk-title">Bookings Management</h1>
                    <p className="bk-sub">View and manage all booking records</p>
                </div>

                <div className="bk-stats">
                    <div className="bk-stat-card">
                        <div className="bk-stat-icon bk-stat-icon--total">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                <path d="M7 13h2M11 13h2M15 13h2M7 17h2M11 17h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="bk-stat-info">
                            <p className="bk-stat-label">Total Bookings</p>
                            <p className="bk-stat-value">{data.length}</p>
                        </div>
                    </div>
                    <div className="bk-stat-card">
                        <div className="bk-stat-icon bk-stat-icon--confirmed">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className="bk-stat-info">
                            <p className="bk-stat-label">Confirmed</p>
                            <p className="bk-stat-value">{data.filter(item => item.status === 'Confirmed').length}</p>
                        </div>
                    </div>
                    <div className="bk-stat-card">
                        <div className="bk-stat-icon bk-stat-icon--pending">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                <circle cx="12" cy="15" r="2" stroke="currentColor" strokeWidth="1.5"/>
                            </svg>
                        </div>
                        <div className="bk-stat-info">
                            <p className="bk-stat-label">Pending</p>
                            <p className="bk-stat-value">{data.filter(item => item.status === 'Pending').length}</p>
                        </div>
                    </div>
                    <div className="bk-stat-card">
                        <div className="bk-stat-icon bk-stat-icon--revenue">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M12 7v10M9.5 9.5C9.5 8.67 10.67 8 12 8s2.5.67 2.5 1.5S13.33 11 12 11s-2.5.67-2.5 1.5S10.67 16 12 16s2.5-.67 2.5-1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="bk-stat-info">
                            <p className="bk-stat-label">Total Revenue</p>
                            <p className="bk-stat-value bk-stat-value--revenue">${data.reduce((sum, item) => sum + Number(item.total_price), 0)}</p>
                        </div>
                    </div>
                </div>

                <div className="bk-filters">
                    <div className="bk-search-wrap">
                        <svg className="bk-search-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M13 13l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <input type="text" className="bk-search" placeholder="Search bookings..." value={search} onChange={e => setSearch(e.target.value)} />
                    </div>
                    <select className="bk-select" value={filterCategory} onChange={e => setFilterCategory(e.target.value)}>
                        <option value="">All Categories</option>
                        {categories.map(cat => (
                            <option key={cat.id} value={String(cat.id)}>{cat.name_en}</option>
                        ))}
                    </select>
                    <select className="bk-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                        <option value="">All Payment Status</option>
                        <option value="Confirmed">Confirmed</option>
                        <option value="Pending">Pending</option>
                        <option value="Failed">Failed</option>
                    </select>
                </div>

                <div className="bk-table-wrap">
                    {loading ? (
                        <p className='loading'>Loading...</p>
                    ) : (
                        <table className="bk-table">
                            <thead>
                                <tr>
                                    <th>Booking ID</th>
                                    <th>Customer</th>
                                    <th>Event</th>
                                    <th>Category</th>
                                    <th>Tickets</th>
                                    <th>Date</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((item) => (
                                    <tr key={item.id}>
                                        <td className="bk-id">{item.booking_id}</td>
                                        <td>
                                            <p className="bk-customer-name">{item.users?.full_name}</p>
                                            <p className="bk-customer-email">{item.email}</p>
                                        </td>
                                        <td className="bk-event">{item.events?.title_en}</td>
                                        <td><span className="bk-category">{item.categories?.name_en}</span></td>
                                        <td className="bk-tickets">{item.ticket_count}</td>
                                        <td className="bk-date">{item.booking_date}</td>
                                        <td className="bk-total">${item.total_price}</td>
                                        <td>
                                            <span className={`bk-payment bk-payment--${item.status.toLowerCase()}`}>{item.status}</span>
                                        </td>
                                        <td>
                                            <div className="bk-actions">
                                                <button className="bk-action-btn bk-action-btn--edit" onClick={() => openEditModal(item)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14.5 2.5a2.121 2.121 0 013 3L6 17H3v-3L14.5 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                                <button className="bk-action-btn bk-action-btn--delete" onClick={() => handleDelete(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </DashLayout>
        </>
    );
};

export default Bookings;